import useInitializeConnectAccountForm from './useInitializeConnectAccountForm'

export default useInitializeConnectAccountForm
